import React, { Component } from 'react';
import CertRequestModel from "../../models/certrequest";
import  PanelLayout  from "../layout/panel-layout";

import PatientPartial from "../partials/patient";
import CertReqPartial from '../partials/certreq';
import CertReqServicePartial from "../partials/certreqservice";
import CertReqPaymentPartial from "../partials/certreqpayment";
import CertReqDocPartial from '../partials/certreqdocs';
import CertReqFormsPartial from '../partials/certreqforms';
import CertUniqueNoModal from '../modal/certuniquenomodal';
import CertRevokeUniqueNoModal from '../modal/certrevokeuniquenomodal';
import {history} from '../../helpers/history';
import  ToggleableLink  from "../../helpers/toggleableLink";
class ShowCertRequest extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           //_model:new CertRequestModel(this.refs),
           model:null,
          // certTypeGroupList:null,
          // certReferenceList:null

          
        };
       
        this.handleTextChange = this.handleTextChange.bind(this);
        
        this.getCertReqServiceData = this.getCertReqServiceData.bind(this);
        
        this.handlebackClick=this.handlebackClick.bind(this);
      
    }

    
    updateCertRefSelect(item) {
        
        let __model = new CertRequestModel(this.refs);  
        __model.CertificationReferenceId=item.value;
        
        console.log('*ITEM*',item);

        this.setState({

            model:__model,
           


        });
       
    }

    handleTextChange(event) {
        this.refreshModel();
    }

    handleDateChange(event) {
      
        this.refreshModel();
    }

    componentWillReceiveProps(newProps)
    {
        console.log('newProps***',newProps)
        const {model}=newProps;
        console.log('-model-',model)


        
        
        if(model!=null)
        {

            this.setState({

                model:model,    
            });
           // alert('model updated');
          //  this.forceUpdate();
        }
       
        
    }

    refreshModel () {
        let __model = new CertRequestModel(this.refs);  
        this.setState({

            _model:__model

        });

        console.log('MODEL',__model);    
    }
    getCertReqServiceData() {
        return this.refs.CertReqServices.getData();
    }
   
    handleClick = (e) => {
        this.props.submitHandler(e);
        // if (this.validator.allValid()) {
            
        //     this.props.submitHandler(e);

        // } else {
        //     this.validator.showMessages();
           
        //     this.forceUpdate();
        // }
    };
    handlebackClick()
    {
        history.goBack();
    }

    

   

    render() { 
        //const {model} = this.props;

        const {model}= this.state;
        const {loading,certTypeGroupList,certTypeList} = this.props;
        //const model=_model;    

        console.log('777model777',model);

        return ( 

        <PanelLayout title={"نمایش درخواست"}>
            <CertUniqueNoModal {...this.props} ref="CertUniqueNoModal"></CertUniqueNoModal>
            <CertRevokeUniqueNoModal {...this.props} ref="CertRevokeUniqueNoModal"></CertRevokeUniqueNoModal>
           
            <div className="panel-body custom">
                <div className="panel panel-default">
                
                    <div className="toolbox">
                    {/*
                        <button type="button"  className="btn btn-default btn-sm" onClick={this.handlebackClick} ><i className="fa fa-arrow-right"></i>   بازگشت
                        
                        </button>
                        &nbsp;&nbsp;
                    */}
                        <button type="button" disabled ={loading } className="btn btn-success btn-sm" onClick={()=>this.props.certissueHandler(model && model.Id)} ><i className="fa fa-file"></i>   صدور گواهی
                            { loading &&
                            <i className="fa fa-spinner fa-spin"></i>
                            }

                        </button>
                        &nbsp;&nbsp;
                        <ToggleableLink  disabled={!(model && model.RequestState == 9)} className="btn btn-success btn-sm" to={`/certreqreport/${model && model.Id}`}><i className="fa fa-print"></i> چاپ گواهی</ToggleableLink>
                        &nbsp;&nbsp;
                        <button type="button" disabled={!(model && model.CertificationType && model.CertificationType.isCertNoNeeded==true && (model.UniqueNo==null || model.UniqueNo==""))}  className="btn btn-warning btn-sm" onClick={()=>this.refs.CertUniqueNoModal.openModal(model && model.Id)} ><i className="fa fa-file"></i>  شماره گواهی
                        </button>

                        &nbsp;&nbsp;
                            
                        <button type="button" disabled={!(model && model.CertificationType && model.CertificationType.isCertNoNeeded==true && (model.UniqueNo!=null || model.UniqueNo!=""))}  className="btn btn-danger btn-sm" onClick={()=>this.refs.CertRevokeUniqueNoModal.openModal(model && model.Id)} ><i className="fa fa-file"></i>  ابطال شماره گواهی
                        </button>

                      
                     
                    </div>
                </div>
            
            <PatientPartial patient={model && model.Patient}></PatientPartial>

            <CertReqPartial model={model}></CertReqPartial>
            <div class="panel panel-default">
                
                <div class="panel-body custom">
            <ul class="nav nav-tabs">
                
                <li ><a data-toggle="tab" href="#home">موارد گواهی</a></li>
                
                <li class="active"><a data-toggle="tab" href="#menu1">اطلاعات فرم</a></li>
                <li><a data-toggle="tab" href="#menu2">پرداخت ها</a></li>
                <li><a data-toggle="tab" href="#menu3">ضمیمه</a></li>
            </ul>

            <div class="tab-content">
                
                <div id="home" class="tab-pane fade in">
                   <CertReqServicePartial btnAddServiceHandler={this.props.btnAddServiceHandler} certTypeGroupList={certTypeGroupList} model={model} certTypeList={certTypeList} {...this.props} ref="CertReqServices"></CertReqServicePartial>
                </div>
                
                <div id="menu1" class="tab-pane fade in active">
                   <CertReqFormsPartial mainmodel={model} {...this.props}></CertReqFormsPartial>
                </div>
                <div id="menu2" class="tab-pane fade">
                   <CertReqPaymentPartial model={model} {...this.props}></CertReqPaymentPartial>
                </div>
                <div id="menu3" class="tab-pane fade">
                   <CertReqDocPartial model={model} {...this.props} ></CertReqDocPartial>
                </div>
            </div>
            </div>
            </div>
                
            
           
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default ShowCertRequest;